<button class="btn btn-sm" [ngClass]="{ 'btn-primary': grande, 'btn-warning': !grande }" (click)="generarEtiquetaPDF()">
  <i class="fas fa-barcode"></i>
</button>